export default "<router-outlet></router-outlet>\n<app-no-internet-connection></app-no-internet-connection>"